import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=1f1e9eca&scoped=true"
import script from "@/views/Groups/Tabs/Files.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Tabs/Files.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/Tabs/files.scss?vue&type=style&index=0&id=1f1e9eca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e9eca",
  null
  
)

export default component.exports